import { IApplicationState } from '../../types/redux';
import { motivationPopupAvailableSelector } from './motivationPopup';

export function accountNameSelector(state: IApplicationState) {
  return state.newbuildingConsultant.accountName;
}

export function chatOpenSelector(state: IApplicationState) {
  return state.newbuildingConsultant.chatOpen;
}

export function needForceOpenSelector(state: IApplicationState) {
  return state.newbuildingConsultant.chatNeedForceOpen && !motivationPopupAvailableSelector(state);
}
